import { getProviderString, mergeThemes } from '@Helpers/hubs'
import { DEFAULT_STYLES } from '@Styles/hubDefaultStyles'
import { action, computed, observable } from 'mobx'
import { BaseStore, getOrCreateStore } from '../../di'

export class HubStore extends BaseStore {
  @observable hubHttpStatusCode = null
  @observable hubAccountState = null

  @observable hubCollaboratorCount = 0
  @observable hubMemberCount = 0

  @observable hubId = null
  @observable hub = null
  @observable partialHub = null
  @observable error = null
  @observable isAuthenticated = false
  @observable isInitialized = false

  @computed
  get hubAccessStatus() {
    switch (this.hubHttpStatusCode) {
      case 200:
        return 'OK'
      case 401:
        return 'REQUIRE_LOGIN'
      case 403:
        return 'REQUIRE_PERMISSION'
      case 404:
        // If the user is logged in then we know for sure the hub does not exist.
        if (this.isAuthenticated) {
          return 'NOT_FOUND'
        } else {
          return 'REQUIRE_PERMISSION'
        }
      case 419:
        return 'AUTHENTICATION_TIMEOUT'
      default:
        return 'UNKNOWN'
    }
  }

  @computed
  get appStyles() {
    const { hub, partialHub } = this
    if (hub) {
      return mergeThemes(DEFAULT_STYLES, hub.theme)
    }
    if (partialHub) {
      return mergeThemes(DEFAULT_STYLES, partialHub.theme)
    }
    return DEFAULT_STYLES
  }

  get SSOButtons() {
    if (!this.partialHub) return []
    const {
      sso_buttons,
      settings: { auth_options },
    } = this.partialHub
    if (!sso_buttons) return []

    // return sso_buttons.filter((item) => auth_options[getProviderString(item.provider_id)])
    return sso_buttons
  }

  @action
  setHubInitialized = () => {
    this.hubInitialized = true
  }

  // Since we don't have an access to sessionStore inside hub store - pass it manually
  @action
  setIsAuthenticated = (isAuthenticated) => {
    this.isAuthenticated = isAuthenticated
  }

  load = (hub) => {
    this.hub = hub
    this.hubAccountState = hub.account_id
    this.hubId = hub.id
    this.hubHttpStatusCode = 200
    this.hubCollaboratorCount = hub.collaborator_count + hub.moderator_count + hub.owner_count
    this.hubMemberCount = hub.member_count
  }

  fetchHub = async (orgUID, hubUID, jwt, apiUrl, csrfToken) => {
    try {
      const res = await this.request(
        {
          path: `/organizations/${orgUID}/hubs/${hubUID}`,
        },
        jwt,
        apiUrl,
        csrfToken
      )

      this.load(res.data)
    } catch (e) {
      this.hubHttpStatusCode = e.status

      if (e.error) {
        this.error = e.error
      }

      if ([401, 403, 419].indexOf(e.status) > -1) {
        if (e.data) {
          this.partialHub = e.data
        }
        return
      }

      return
    }
  }
}

export default getOrCreateStore('HubStore', HubStore)
